export const data = [
  { datetime: 1653782400000, value: "561989" },
  { datetime: 1653868800000, value: "580208" },
  { datetime: 1653955200000, value: "602684" },
  { datetime: 1654041600000, value: "609673" },
  { datetime: 1654128000000, value: "614118" },
  { datetime: 1654214400000, value: "618699" },
  { datetime: 1654300800000, value: "622016" },
  { datetime: 1654387200000, value: "625392" },
  { datetime: 1654473600000, value: "628643" },
  { datetime: 1654560000000, value: "632181" },
  { datetime: 1654646400000, value: "636023" },
  { datetime: 1654732800000, value: "638492" },
  { datetime: 1654819200000, value: "640676" },
  { datetime: 1654905600000, value: "641969" },
  { datetime: 1654992000000, value: "643279" },
  { datetime: 1655078400000, value: "644676" },
  { datetime: 1655164800000, value: "645932" },
  { datetime: 1655251200000, value: "646967" },
  { datetime: 1655337600000, value: "647905" },
  { datetime: 1655424000000, value: "648695" },
  { datetime: 1655510400000, value: "649693" },
  { datetime: 1655596800000, value: "650573" },
  { datetime: 1655683200000, value: "651891" },
  { datetime: 1655769600000, value: "652626" },
  { datetime: 1655856000000, value: "653659" },
  { datetime: 1655942400000, value: "654568" },
  { datetime: 1656028800000, value: "655240" },
  { datetime: 1656115200000, value: "655731" },
  { datetime: 1656201600000, value: "656235" },
  { datetime: 1656288000000, value: "657132" },
  { datetime: 1656374400000, value: "658491" },
  { datetime: 1656460800000, value: "659744" },
  { datetime: 1656547200000, value: "660496" },
  { datetime: 1656633600000, value: "661127" },
  { datetime: 1656720000000, value: "661801" },
  { datetime: 1656806400000, value: "662319" },
  { datetime: 1656892800000, value: "662785" },
  { datetime: 1656979200000, value: "663621" },
  { datetime: 1657065600000, value: "664089" },
  { datetime: 1657152000000, value: "664479" },
  { datetime: 1657238400000, value: "664906" },
  { datetime: 1657324800000, value: "665256" },
  { datetime: 1657411200000, value: "665800" },
  { datetime: 1657497600000, value: "666154" },
  { datetime: 1657584000000, value: "666533" },
  { datetime: 1657670400000, value: "667563" },
  { datetime: 1657756800000, value: "667867" },
  { datetime: 1657843200000, value: "672537" },
  { datetime: 1657929600000, value: "672854" },
  { datetime: 1658016000000, value: "673154" },
  { datetime: 1658102400000, value: "673550" },
  { datetime: 1658188800000, value: "674169" },
  { datetime: 1658275200000, value: "675307" },
  { datetime: 1658361600000, value: "675623" },
  { datetime: 1658448000000, value: "675946" },
  { datetime: 1658534400000, value: "676235" },
  { datetime: 1658620800000, value: "676540" },
  { datetime: 1658707200000, value: "676798" },
  { datetime: 1658793600000, value: "677074" },
  { datetime: 1658880000000, value: "677344" },
  { datetime: 1658966400000, value: "677683" },
  { datetime: 1659052800000, value: "679787" },
  { datetime: 1659139200000, value: "680151" },
  { datetime: 1659225600000, value: "680539" },
  { datetime: 1659312000000, value: "681067" },
  { datetime: 1659398400000, value: "681765" },
  { datetime: 1659484800000, value: "682095" },
  { datetime: 1659571200000, value: "682359" },
  { datetime: 1659657600000, value: "682629" },
  { datetime: 1659744000000, value: "682918" },
  { datetime: 1659830400000, value: "683189" },
  { datetime: 1659916800000, value: "683521" },
  { datetime: 1660003200000, value: "683822" },
  { datetime: 1660089600000, value: "684140" },
];
export const dataNew = [
  { datetime: 1653782400000, value: "17365" },
  { datetime: 1653868800000, value: "18219" },
  { datetime: 1653955200000, value: "22476" },
  { datetime: 1654041600000, value: "6989" },
  { datetime: 1654128000000, value: "4445" },
  { datetime: 1654214400000, value: "4581" },
  { datetime: 1654300800000, value: "3317" },
  { datetime: 1654387200000, value: "3376" },
  { datetime: 1654473600000, value: "3251" },
  { datetime: 1654560000000, value: "3538" },
  { datetime: 1654646400000, value: "3842" },
  { datetime: 1654732800000, value: "2469" },
  { datetime: 1654819200000, value: "2184" },
  { datetime: 1654905600000, value: "1293" },
  { datetime: 1654992000000, value: "1310" },
  { datetime: 1655078400000, value: "1397" },
  { datetime: 1655164800000, value: "1256" },
  { datetime: 1655251200000, value: "1035" },
  { datetime: 1655337600000, value: "938" },
  { datetime: 1655424000000, value: "790" },
  { datetime: 1655510400000, value: "998" },
  { datetime: 1655596800000, value: "880" },
  { datetime: 1655683200000, value: "1318" },
  { datetime: 1655769600000, value: "735" },
  { datetime: 1655856000000, value: "1033" },
  { datetime: 1655942400000, value: "909" },
  { datetime: 1656028800000, value: "672" },
  { datetime: 1656115200000, value: "491" },
  { datetime: 1656201600000, value: "504" },
  { datetime: 1656288000000, value: "897" },
  { datetime: 1656374400000, value: "1359" },
  { datetime: 1656460800000, value: "1253" },
  { datetime: 1656547200000, value: "752" },
  { datetime: 1656633600000, value: "631" },
  { datetime: 1656720000000, value: "674" },
  { datetime: 1656806400000, value: "518" },
  { datetime: 1656892800000, value: "466" },
  { datetime: 1656979200000, value: "836" },
  { datetime: 1657065600000, value: "468" },
  { datetime: 1657152000000, value: "390" },
  { datetime: 1657238400000, value: "427" },
  { datetime: 1657324800000, value: "350" },
  { datetime: 1657411200000, value: "544" },
  { datetime: 1657497600000, value: "354" },
  { datetime: 1657584000000, value: "379" },
  { datetime: 1657670400000, value: "1030" },
  { datetime: 1657756800000, value: "304" },
  { datetime: 1657843200000, value: "4670" },
  { datetime: 1657929600000, value: "317" },
  { datetime: 1658016000000, value: "300" },
  { datetime: 1658102400000, value: "396" },
  { datetime: 1658188800000, value: "619" },
  { datetime: 1658275200000, value: "1138" },
  { datetime: 1658361600000, value: "316" },
  { datetime: 1658448000000, value: "323" },
  { datetime: 1658534400000, value: "289" },
  { datetime: 1658620800000, value: "305" },
  { datetime: 1658707200000, value: "258" },
  { datetime: 1658793600000, value: "276" },
  { datetime: 1658880000000, value: "270" },
  { datetime: 1658966400000, value: "339" },
  { datetime: 1659052800000, value: "2104" },
  { datetime: 1659139200000, value: "364" },
  { datetime: 1659225600000, value: "388" },
  { datetime: 1659312000000, value: "528" },
  { datetime: 1659398400000, value: "698" },
  { datetime: 1659484800000, value: "330" },
  { datetime: 1659571200000, value: "264" },
  { datetime: 1659657600000, value: "270" },
  { datetime: 1659744000000, value: "289" },
  { datetime: 1659830400000, value: "271" },
  { datetime: 1659916800000, value: "332" },
  { datetime: 1660003200000, value: "301" },
  { datetime: 1660089600000, value: "318" },
];
export const dataActive = [
  { datetime: 1653696000000, value: "56778" },
  { datetime: 1653782400000, value: "21786" },
  { datetime: 1653868800000, value: "28620" },
  { datetime: 1653955200000, value: "28856" },
  { datetime: 1654041600000, value: "9675" },
  { datetime: 1654128000000, value: "7173" },
  { datetime: 1654214400000, value: "7122" },
  { datetime: 1654300800000, value: "5637" },
  { datetime: 1654387200000, value: "6281" },
  { datetime: 1654473600000, value: "5978" },
  { datetime: 1654560000000, value: "8425" },
  { datetime: 1654646400000, value: "9078" },
  { datetime: 1654732800000, value: "5808" },
  { datetime: 1654819200000, value: "5005" },
  { datetime: 1654905600000, value: "3253" },
  { datetime: 1654992000000, value: "3513" },
  { datetime: 1655078400000, value: "3751" },
  { datetime: 1655164800000, value: "3364" },
  { datetime: 1655251200000, value: "2958" },
  { datetime: 1655337600000, value: "2856" },
  { datetime: 1655424000000, value: "2562" },
  { datetime: 1655510400000, value: "3367" },
  { datetime: 1655596800000, value: "3074" },
  { datetime: 1655683200000, value: "4185" },
  { datetime: 1655769600000, value: "3012" },
  { datetime: 1655856000000, value: "3210" },
  { datetime: 1655942400000, value: "3423" },
  { datetime: 1656028800000, value: "2384" },
  { datetime: 1656115200000, value: "2100" },
  { datetime: 1656201600000, value: "2235" },
  { datetime: 1656288000000, value: "3492" },
  { datetime: 1656374400000, value: "4250" },
  { datetime: 1656460800000, value: "3769" },
  { datetime: 1656547200000, value: "2904" },
  { datetime: 1656633600000, value: "2549" },
  { datetime: 1656720000000, value: "2435" },
  { datetime: 1656806400000, value: "2159" },
  { datetime: 1656892800000, value: "2360" },
  { datetime: 1656979200000, value: "2618" },
  { datetime: 1657065600000, value: "2966" },
  { datetime: 1657152000000, value: "2160" },
  { datetime: 1657238400000, value: "2244" },
  { datetime: 1657324800000, value: "1943" },
  { datetime: 1657411200000, value: "2188" },
  { datetime: 1657497600000, value: "2164" },
  { datetime: 1657584000000, value: "2233" },
  { datetime: 1657670400000, value: "3545" },
  { datetime: 1657756800000, value: "2000" },
  { datetime: 1657843200000, value: "11978" },
  { datetime: 1657929600000, value: "2238" },
  { datetime: 1658016000000, value: "2064" },
  { datetime: 1658102400000, value: "2656" },
  { datetime: 1658188800000, value: "2634" },
  { datetime: 1658275200000, value: "4258" },
  { datetime: 1658361600000, value: "1879" },
  { datetime: 1658448000000, value: "1900" },
  { datetime: 1658534400000, value: "1733" },
  { datetime: 1658620800000, value: "1823" },
  { datetime: 1658707200000, value: "1883" },
  { datetime: 1658793600000, value: "1832" },
  { datetime: 1658880000000, value: "1892" },
  { datetime: 1658966400000, value: "2047" },
  { datetime: 1659052800000, value: "6941" },
  { datetime: 1659139200000, value: "2314" },
  { datetime: 1659225600000, value: "2602" },
  { datetime: 1659312000000, value: "4408" },
  { datetime: 1659398400000, value: "3632" },
  { datetime: 1659484800000, value: "2319" },
  { datetime: 1659571200000, value: "2070" },
  { datetime: 1659657600000, value: "2021" },
  { datetime: 1659744000000, value: "1893" },
  { datetime: 1659830400000, value: "2060" },
  { datetime: 1659916800000, value: "2302" },
  { datetime: 1660003200000, value: "2093" },
  { datetime: 1660089600000, value: "2140" },
];
export const groupButton = [
  {
    id: "1",
    name: "From genesis",
  },
  {
    id: "2",
    name: "7 days",
  },
  {
    id: "3",
    name: "14 days",
  },
  {
    id: "4",
    name: "30 days",
  },
];
